import { AlertTriangle, Info, CheckCircle, AlertOctagon, Siren } from "lucide-react";

const variants = {
  info: {
    bg: "#E3F0F5",
    border: "1px solid rgba(0,98,143,0.15)",
    color: "#00628F",
    Icon: Info,
  },
  warning: {
    bg: "#FFF3DC",
    border: "1px solid rgba(249,160,27,0.15)",
    color: "#D9880F",
    Icon: AlertTriangle,
  },
  danger: {
    bg: "#FCEAE8",
    border: "1px solid rgba(192,69,58,0.15)",
    color: "#C0453A",
    Icon: AlertOctagon,
  },
  critical: {
    bg: "#FFF0F0",
    border: "2px solid #C0453A",
    color: "#9B1C1C",
    Icon: Siren,
    pulse: true,
  },
  success: {
    bg: "#E2F0E8",
    border: "1px solid rgba(21,115,70,0.15)",
    color: "#157346",
    Icon: CheckCircle,
  },
};

export function AlertBanner({ variant = "info", children, testId }) {
  const v = variants[variant] || variants.info;
  const IconComponent = v.Icon;

  return (
    <div
      data-testid={testId}
      className={`flex gap-2.5 items-start rounded-[14px]${v.pulse ? " we360-pulse-border" : ""}`}
      style={{ padding: 16, background: v.bg, border: v.border }}
    >
      <IconComponent size={18} color={v.color} className="shrink-0 mt-0.5" />
      <div className="text-xs leading-relaxed font-medium" style={{ color: "#2D2A24" }}>
        {children}
      </div>
    </div>
  );
}
